import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Grid,
  Header,
  Icon,
  Input,
  Item,
  Menu,
  Modal,
  Table,
  TextArea,
} from "semantic-ui-react";
import ServiceApi from "../../api/service";
import Logo from "../../components/Logo/Logo";

import { useAppDispatch as useDispatch } from "../../hooks/redux";

import { setService } from "../../redux/actions/service";
import { ServiceContractBase } from "../../types/serviceContractBase";

import { setEmail as setEmailRedux } from "../../redux/actions/admin";

import style from "./style.module.css";
import { downloadFile } from "../../utils/downloadFile";
import { contractTypeSupported } from "../../utils/contractType";
import { useUploadFile } from "../../hooks/useUploadFile";

export default function ServiceTablePage() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [responsibleName, setResponsibleName] = useState("");
  const [responsibleEmail, setResponsibleEmail] = useState("");
  const [witnessName, setWitnessName] = useState("");
  const [witnessEmail, setWitnessEmail] = useState("");

  const [contract, setContract] = useState<ServiceContractBase>();
  const [modalVisible, setModalVisible] = useState(false);
  const [keepConditionsModalVisible, setKeepConditionsModalVisible] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [keepConfirmationModal, setKeepConfirmationModal] = useState(false);
  const [problemModal, setProblemModal] = useState(false);
  const [problem, setProblem] = useState("");

  const { handleUploadFile, responseOk } = useUploadFile(contract?.id as number, contractTypeSupported.BR_SERVICES, "br");

  const validateEmail = (email: string) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  const history = useHistory();
  const updatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await ServiceApi.updateContract(
        responsibleName.trim(),
        responsibleEmail.trim(),
        witnessName.trim(),
        witnessEmail.trim()
      );
      setConfirmationModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de salvar");
    }
    setLoading(false);
  };

  const partialUpdatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await ServiceApi.partialUpdateContract(
        responsibleName.trim(),
        responsibleEmail.trim(),
        witnessName.trim(),
        witnessEmail.trim()
      );
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const setKeepConditions = async (keepConditions: boolean) => {
    setLoading(true);
    setError("");
    try {
      await ServiceApi.setKeepConditions(keepConditions);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const sendProblem = async () => {
    setLoading(true);
    setError("");
    try {
      await ServiceApi.setProblem(problem);
      setProblemModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de enviar");
    }
    setLoading(false);
  };
  const getContract = async () => {
    setLoading(true);
    try {
      const contract = await ServiceApi.getContract();
      const mat = contract.serviceBases.sort(function (a, b) {
        let x = a.id;
        let y = b.id;
        return x < y ? -1 : x > y ? 1 : 0;
      });
      if (contract.keepConditions === null && contract.round === 0) {
        setKeepConditionsModalVisible(true);
      } else {
        setContract({ ...contract, serviceBases: mat });
        if (contract.serviceContractUpdate) {
          setResponsibleName(contract.serviceContractUpdate.responsibleName);
          setResponsibleEmail(contract.serviceContractUpdate.responsibleEmail);
          setWitnessName(contract.serviceContractUpdate.witnessName);
          setWitnessEmail(contract.serviceContractUpdate.witnessEmail);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const verifyForm = () => {
    if (
      responsibleName === "" ||
      responsibleEmail === "" ||
      witnessName === "" ||
      witnessEmail === ""
    ) {
      return false;
    }
    if (!validateEmail(responsibleEmail) || !validateEmail(witnessEmail)) {
      return false;
    }
    return true;
  };

  const execDownloadFile = async () => {
		try {
      if (contract?.id) {
        downloadFile(contract.id.toString(), contractTypeSupported.BR_SERVICES);
      }
		} catch (err) {
      console.log(err);
      setError("Problema ao exportar");
		}
	}

  useEffect(() => {
    getContract();
  }, []);

  useEffect(() => {
    if (responseOk) {      
      getContract();
    }
  }, [responseOk]);

  return (
    <div className={style.container}>
      <Modal
        onClose={() => {
          setProblemModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginService/${contract?.id}`);
        }}
        onOpen={() => setProblemModal(true)}
        open={problemModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu problema foi enviado com sucesso, logo entraremos em contato
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setProblemModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginService/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConditionsModalVisible(true)}
        open={keepConditionsModalVisible}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Podemos manter as condições do contrato por mais um ano?
            </Header>
            <Grid.Column>
              <Grid.Row textAlign="left">
                <label>Nome do responsável legal *: </label>
                <br />
                <label>(Pessoa que assinará o contrato) </label>
                <br />

                <Input
                  value={responsibleName}
                  onChange={(e) => {
                    setResponsibleName(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Responsável"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Email do responsável legal *: </label>
                <br />
                <Input
                  error={!validateEmail(responsibleEmail)}
                  value={responsibleEmail}
                  onChange={(e) => {
                    setResponsibleEmail(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Email"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Nome da testemunha *: </label>
                <br />
                <label>(Qualquer outro funcionário) </label>
                <br />
                <Input
                  value={witnessName}
                  onChange={(e) => {
                    setWitnessName(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Nome de testemunha"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Email da testemunha *: </label>
                <br />
                <Input
                  error={!validateEmail(witnessEmail)}
                  value={witnessEmail}
                  onChange={(e) => {
                    setWitnessEmail(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Nome de testemunha"
                />
              </Grid.Row>
              <br />
            </Grid.Column>
            <p>
              Obs: Abrindo uma renegociação a companhia poderá iniciar um novo
              leilão.
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Verificar condições"
            // labelPosition="right"
            onClick={async () => {
              await setKeepConditions(true);
              await getContract();
              await setKeepConditionsModalVisible(false);
            }}
            negative
          />
          <Button
            disabled={!verifyForm()}
            loading={loading}
            content="Manter"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConfirmationModal(true);
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConfirmationModal(true)}
        open={keepConfirmationModal}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Confirma que deseja manter as condições atuais?</Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Cancelar"
            // labelPosition="right"
            onClick={async () => {
              setKeepConfirmationModal(false);
              setKeepConditionsModalVisible(true);
            }}
            negative
          />
          <Button
            disabled={!verifyForm()}
            loading={loading}
            content="Sim"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConditions(true);
              updatedContract();
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onClose={() => {
          setConfirmationModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginService/${contract?.id}`);
        }}
        onOpen={() => setConfirmationModal(true)}
        open={confirmationModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu contrato foi enviado com sucesso, entraremos em contato
              finalizando a negociação ou com uma contraproposta
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setConfirmationModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginService/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => setModalVisible(false)}
        onOpen={() => setModalVisible(true)}
        open={modalVisible}
      >
        <Modal.Header>Problema</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Estou com um problema</Header>
            <p>Descreva o seu problema</p>
          </Modal.Description>
          <TextArea
            cols="100"
            placeholder="Nos conte mais sobre seu problema"
            value={problem}
            onChange={(e, data) => {
              setProblem(data.value!.toString());
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>
          <Button
            content="Enviar e finalizar negociação"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setModalVisible(false);
              sendProblem();
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Logo />
      <Button
        floated="right"
        loading={loading}
        color="red"
        onClick={() => setModalVisible(true)}
      >
        Estou com um Problema
      </Button>
      {/* <Header as="h1">Smart Contract</Header> */}

      <Grid columns={4} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Contrato</Item.Header>
                <Item.Meta>
                  <label>Numero:</label>
                  <span>{contract?.contractId}</span>
                  <br />
                  <label>Fornecedor:</label>
                  <span>{contract?.supplierName}</span>
                  <br />
                  <label>Moeda:</label>
                  <span>{contract?.currency}</span>
                  <br />
                  <label>CNPJ:</label>
                  <span>{contract?.fiscalCode}</span>
                  <br />
                  <label>Centro:</label>
                  <span>{contract?.company}</span>
                  {/* <br />
                  <label>Prazo de pagamento:</label>
                  <span>{contract?.paymentTerm}</span> */}
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Nome do responsável legal *: </label>
            <br />
            <label>(Pessoa que assinará o contrato) </label>
            <br />

            <Input
              value={responsibleName}
              onChange={(e) => {
                setResponsibleName(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Responsável"
            />
          </Grid.Row>
          <Grid.Row textAlign="left">
            <label>Email do responsável legal *: </label>
            <br />
            <Input
              error={!validateEmail(responsibleEmail)}
              value={responsibleEmail}
              onChange={(e) => {
                setResponsibleEmail(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Email"
            />
          </Grid.Row>
          <br />
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Nome da testemunha *: </label>
            <br />
            <label>(Qualquer outro funcionario) </label>
            <br />
            <Input
              value={witnessName}
              onChange={(e) => {
                setWitnessName(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Nome de testemunha"
            />
          </Grid.Row>
          <Grid.Row textAlign="left">
            <label>Email da testemunha *: </label>
            <br />
            <Input
              error={!validateEmail(witnessEmail)}
              value={witnessEmail}
              onChange={(e) => {
                setWitnessEmail(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Email da testemunha"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <text>Preencha todos os campos *</text>
          <br />
          {contract?.keepConditions === false ? (
            <Button
              loading={loading}
              primary
              disabled={!verifyForm()}
              onClick={updatedContract}
            >
              Enviar negociação
            </Button>
          ) : (
            <>
              <Button
                loading={loading}
                color="red"
                onClick={async () => {
                  await setKeepConditions(false);
                  await getContract();
                }}
              >
                Renegociar
              </Button>
              <Button
                loading={loading}
                color="green"
                disabled={!verifyForm()}
                onClick={updatedContract}
              >
                Aceitar
              </Button>
              <br />
              <text>Obs: Renegociação poderá iniciar um novo leilão.</text>
            </>
          )}
          <br />
          <text className={style.error}>{error}</text>
        </Grid.Column>
      </Grid>
      <Grid.Column style={{display: "flex", justifyContent: "right"}}>          
        <Dropdown text="Negociação em massa" className="selection">
          <DropdownMenu>
            <DropdownItem text="Exportar Modelo" onClick={execDownloadFile}/>
            <DropdownItem text="Importar Excel" onClick={handleUploadFile}/>
          </DropdownMenu>
        </Dropdown>
      </Grid.Column>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>Preço Bruto atual</Table.HeaderCell>
            <Table.HeaderCell>Preço Bruto Proposto</Table.HeaderCell>
            <Table.HeaderCell>Reajuste Percentual</Table.HeaderCell>
            <Table.HeaderCell>Descrição</Table.HeaderCell>
            <Table.HeaderCell>Subdescrição</Table.HeaderCell>
            <Table.HeaderCell>ISS %</Table.HeaderCell>
            <Table.HeaderCell>PIS %</Table.HeaderCell>
            <Table.HeaderCell>COFINS %</Table.HeaderCell>
            {contract?.keepConditions === false ? (
              <Table.HeaderCell>Novo preço (Opcional)</Table.HeaderCell>
            ) : null}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {contract?.serviceBases.map((service) => {
            return (
              <Table.Row key={service.service}>
                <Table.Cell>{service.service}</Table.Cell>
                <Table.Cell>
                  {service.price + " " + contract.currency}
                </Table.Cell>
                <Table.Cell>
                  {service.negotiationPrice
                    ? service.negotiationPrice + " " + contract.currency
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {service.negotiationPrice
                    ? (
                        (parseFloat(service.negotiationPrice) / service.price -
                          1) *
                        100
                      ).toFixed(2) + "%"
                    : ""}
                </Table.Cell>
                <Table.Cell>{service.description}</Table.Cell>
                <Table.Cell>{service.longDescription}</Table.Cell>
                <Table.Cell>{service.serviceUpdate?.issRate ?? "0.00"}</Table.Cell>
                <Table.Cell>{service.serviceUpdate?.pisRate ?? "0.00"}</Table.Cell>
                <Table.Cell>{service.serviceUpdate?.cofinsRate ?? "0.00"}</Table.Cell>

                {contract?.keepConditions === false ? (
                  <Table.Cell>
                    <Button
                      animated="vertical"
                      color={service.updated ? "yellow" : "grey"}
                      onClick={() => {
                        dispatch(setService(service));
                        history.push({
                          pathname: `/serviceContract/service`,
                        });
                      }}
                      disabled={service.discontinued}
                    >
                      <Button.Content visible>
                        {service.updated ? "Preço proposto" : "Novo preço"}
                      </Button.Content>
                      <Button.Content hidden>
                        <Icon name="edit" />
                      </Button.Content>
                    </Button>
                  </Table.Cell>
                ) : null}
              </Table.Row>
            );
          })}
        </Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="10">
              <Menu floated="right" pagination>
                <Menu.Item
                  icon
                  onClick={() => {
                    //previus
                  }}
                >
                  <Icon name="chevron left" />
                </Menu.Item>
                <Menu.Item>{/* {page} of {totalPages} */}1 of 1</Menu.Item>
                <Menu.Item
                  icon
                  onClick={() => {
                    //onNextClick
                  }}
                >
                  <Icon name="chevron right" />
                </Menu.Item>
              </Menu>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}
